export default __webpack_public_path__ + "static/media/p11.c6812d15.jpg";